import React, {Component} from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import {connect} from 'react-redux';
import {compose} from 'recompose';
import CategoriesPurchasedTable from './CategoriesPurchasedTable';
import LocationSalesTable from './LocationSalesTable';
import ProductUnitsPurchasedTable from './ProductUnitsPurchasedTable';
import ReactToPrint from 'react-to-print';
import {displayDateRangeString, toCurrency} from '../shared/functions';
import {getGetHeaders} from '../shared/serverFunctions';
import {createTableRow, populateCategoryTable, populateProductUnitTable} from '../shared/reportTableFunctions';
import {checkTokenStatus} from '../shared/tokenFunctions';
import {RESOURCES as reportsResources} from '../fuseItemSalesReportsResourceMap';
import '../shared/react-table.css';
import {tableStyles} from '../shared/styles-table';
import CircularProgress from 'material-ui/CircularProgress';
import RaisedButton from 'material-ui/RaisedButton';
import Config from '../messages';

/**
 * Class for retrieving and displaying Item Sales data for multiple tables
 *
 */
class ItemSalesReportSet extends Component {
    constructor(props) {
        super(props);
        this.state = {
            allowLocationSelection: true,
            countType: null,
            countValid: true,
            countValue: {
                id1: null,
                id2: null
            },
            dataIsFiltered: false,
            dataSet1Complete: false,
            errorMessage1: null,
            errorMessage2: null,
            headerSet1: {
                type: null,
                choice: null
            },
            headerSet2: {
                dba: {
                    name: null
                },
                id: null,
                name: null,
                city: null,
                state: null
            },
            loadingData1: props.showLoading,
            loadingData2: false,
            selectedLocation: {
                id: null,
                name: null,
                dba_name: null,
                city: null,
                selected: false,
                state: null,
                type: null,
                zipcode: null
            },
            tableSet1Categories: [],
            tableSet1Locations: [],
            tableSet1Products: [],
            tableSet2Categories: [],
            tableSet2Products: []
        };
        this.area2Position = null;
        this.handleLocationSelect = this.handleLocationSelect.bind(this);
    }

    componentWillMount() {
        this.setDataForFetch('all_count');
    }

    componentWillReceiveProps(nextProps) {
        let clearData = false;
        // If date range or filter choices change, reset
        if (
            nextProps.startDate !== this.props.startDate ||
            nextProps.endDate !== this.props.endDate ||
            nextProps.offset !== this.props.offset ||
            nextProps.filterChoiceFirst !== this.props.filterChoiceFirst ||
            nextProps.filterChoiceSecond !== this.props.filterChoiceSecond ||
            nextProps.filterType !== this.props.filterType ||
            nextProps.showLoading !== this.props.showLoading
        ) {
            clearData = true;
        }
        if (clearData) {
            this.setState({
                allowLocationSelection: true,
                dataSet1Complete: false,
                loadingData1: nextProps.showLoading,
                loadingData2: false,
                selectedLocation: {
                    id: null,
                    name: null,
                    dba_name: null,
                    city: null,
                    selected: false,
                    state: null,
                    type: null,
                    zipcode: null
                },
                tableSet1Categories: [],
                tableSet1Locations: [],
                tableSet1Products: [],
                tableSet2Categories: [],
                tableSet2Products: []
            });
        }
    }

    componentDidUpdate(prevProps) {
        let dataTypeToFetch = 'none';
        if (
            prevProps.startDate !== this.props.startDate ||
            prevProps.endDate !== this.props.endDate ||
            prevProps.offset !== this.props.offset ||
            (prevProps.filterType !== 'all' && this.props.filterType === 'all')
        ) {
            dataTypeToFetch = 'all';
        }
        if (
            prevProps.filterChoiceFirst !== this.props.filterChoiceFirst ||
            prevProps.filterChoiceSecond !== this.props.filterChoiceSecond ||
            prevProps.totalFiltersAvailable !== this.props.totalFiltersAvailable
        ) {
            if (this.props.totalFiltersAvailable === 2) {
                dataTypeToFetch = (this.props.filterChoiceSecond) ? 'filter' : 'none';
            } else if (this.props.totalFiltersAvailable === 1) {
                dataTypeToFetch = 'filter';
            }
        }
        if (dataTypeToFetch === 'filter') {
            this.setDataForFetch(prevProps.filterType + '_count');
        } else if (dataTypeToFetch === 'all') {
            this.setDataForFetch('all_count');
        }
    }

    /* API Calls ------------------------------ */

    /**
     * Set up call for data by a specific date range
     *
     * @param dataType
     * @param selectedValue
     */
    setDataForFetch(dataType, selectedValue = null) {

        const params = {
            start_date: this.props.startDate,
            end_date: this.props.endDate,
            offset: this.props.offset,
        };

        // Update parameters and set resource based on data filter
        let resource;
        let reportName = 'Item Sales';

        let firstFilterValue, secondFilterValue;
        if (dataType !== 'all') {
            if (this.props.filterChoiceFirst) {
                firstFilterValue = this.props.filterChoiceFirst;
            }
            if (this.props.filterChoiceSecond) {
                secondFilterValue = this.props.filterChoiceSecond;
            }
        }
        let dataIsFiltered = (dataType !== 'all');
        let locationId = (this.state.selectedLocation && this.state.selectedLocation.id) ? this.state.selectedLocation.id : null;
        let countType = null;
        let countValue = {
            id1: null,
            id2: null
        };

        // Do not continue if filter choices are not available due to Primary/Secondary toggling, or if no Location is selected
        if (dataType.indexOf('all') === -1 && !firstFilterValue && !locationId) {
            return;
        }

        // Set additional params and select API path based on data type
        // All Item Sales API calls require a call for count totals before data retrieval
        switch (dataType) {
            case 'statecity_count' :
                // Retrieve totals before calling for data by Filter: State and City
                countType = 'statecity';
                countValue.id1 = firstFilterValue;
                countValue.id2 = secondFilterValue;
                params.dba_id = firstFilterValue;
                resource = reportsResources.ItemSalesCountByStateCity.GET_LIST(params);
                reportName = 'Item Sales by State and City';
                break;
            case 'statecity':
                // Filter: State and City
                params.state = firstFilterValue;
                params.city = secondFilterValue;
                resource = reportsResources.ItemSalesByStateCity.GET_LIST(params);
                reportName = 'Item Sales by State and City';
                break;
            case 'statedba_count' :
                // Retrieve totals before calling for data by Filter: State and DBA
                countType = 'statedba';
                countValue.id1 = firstFilterValue;
                countValue.id2 = secondFilterValue;
                params.state = firstFilterValue;
                params.dba_id = secondFilterValue;
                resource = reportsResources.ItemSalesCountByStateDba.GET_LIST(params);
                reportName = 'Item Sales by State and DBA';
                break;
            case 'statedba':
                // Filter: State and DBA
                params.state = firstFilterValue;
                params.dba_id = secondFilterValue;
                resource = reportsResources.ItemSalesByStateDba.GET_LIST(params);
                reportName = 'Item Sales by State and DBA';
                break;
            case 'dba_count' :
                // Retrieve totals before calling for data by Filter: DBA
                countType = 'dba';
                countValue.id1 = firstFilterValue;
                params.dba_id = firstFilterValue;
                resource = reportsResources.ItemSalesCountByDba.GET_LIST(params);
                reportName = 'Item Sales by DBA';
                break;
            case 'dba':
                // Filter: DBA
                params.dba_id = firstFilterValue;
                resource = reportsResources.ItemSalesByDba.GET_LIST(params);
                reportName = 'Item Sales by DBA';
                break;
            case 'district_count' :
                // Retrieve totals before calling for data by Filter: District
                countType = 'district';
                countValue.id1 = firstFilterValue;
                params.district_id = firstFilterValue;
                resource = reportsResources.ItemSalesCountByDistrict.GET_LIST(params);
                reportName = 'Item Sales by District';
                break;
            case 'district':
                // Filter: District
                params.district_id = firstFilterValue;
                resource = reportsResources.ItemSalesByDistrict.GET_LIST(params);
                reportName = 'Item Sales by District';
                break;
            case 'location_count' :
                // Retrieve totals before calling for data by Filter: Location
                countType = 'location';
                countValue.id1 = firstFilterValue;
                params.location_id = (locationId) ? locationId : firstFilterValue;
                resource = reportsResources.ItemSalesCountByLocation.GET_LIST(params);
                reportName = 'Item Sales by Location ' + firstFilterValue;
                break;
            case 'location':
                // Filter: Location
                params.location_id = (locationId) ? locationId : firstFilterValue;
                resource = reportsResources.ItemSalesByLocation.GET_LIST(params);
                reportName = 'Item Sales by Location ' + firstFilterValue;
                break;
            case 'selected_location_count' :
                // Retrieve totals before calling for data by selected Location
                countType = 'location';
                countValue.id1 = locationId;
                params.location_id = locationId;
                resource = reportsResources.ItemSalesCountByLocation.GET_LIST(params);
                reportName = 'Item Sales by Location ' + this.state.selectedLocation.id;
                break;
            case 'selected_location' :
                // Select Location ID in area 1: Retrieve data
                params.location_id = locationId;
                resource = reportsResources.ItemSalesByLocation.GET_LIST(params);
                reportName = 'Item Sales by Location ' + locationId;
                break;
            case 'state_count' :
                // Retrieve totals before calling for data by Filter: State
                countType = 'state';
                countValue.id1 = firstFilterValue;
                params.state = firstFilterValue;
                resource = reportsResources.ItemSalesCountByState.GET_LIST(params);
                reportName = 'Item Sales by State';
                break;
            case 'state':
                // Filter: State
                params.state = firstFilterValue;
                resource = reportsResources.ItemSalesByState.GET_LIST(params);
                reportName = 'Item Sales by State';
                break;
            case 'all_count' :
                // Retrieve totals before calling for all data
                countType = 'all';
                resource = reportsResources.ItemSalesCount.GET_LIST(params);
                break;
            case 'all':
                // Filter: All
                resource = reportsResources.ItemSalesAll.GET_LIST(params);
                break;
            default:
                // Get all data
                resource = reportsResources.ItemSalesAll.GET_LIST(params);
                break;
        }

        // If the request requires a count check, store the requested data before calling
        if (dataType.indexOf('_count') !== -1) {
            this.setState({
                countType: countType,
                countValid: true,
                countValue: {
                    id1: countValue.id1,
                    id2: countValue.id2
                },
            }, () => {
                let countSettings = {
                    countType: countType,
                    countValue: {
                        id1: countValue.id1,
                        id2: countValue.id2
                    }
                };
                this.fetchData(dataType, resource.uri, reportName, countSettings, dataIsFiltered, locationId)
            });
        } else {
            this.fetchData(dataType, resource.uri, reportName, null, dataIsFiltered, locationId)
        }
    }

    /**
     * Get filtered data by a specific date range
     *
     * @param dataType
     * @param resourceURI
     * @param reportName
     * @param countSettings
     * @param dataIsFiltered
     * @param locationId
     */
    fetchData(dataType, resourceURI, reportName, countSettings, dataIsFiltered, locationId) {

        const tokenStatus = checkTokenStatus(null);
        if (tokenStatus.expired) {
            return;
        }

        axios({
            method: 'get',
            url: resourceURI,
            headers: getGetHeaders()
        }).then((result) => {
            if (result.data && result.data.payload) {
                if (dataType.indexOf('_count') !== -1) {
                    // Locations may be filtered or selected
                    let isSelected = false;
                    if (dataType === 'location_count' && this.state.selectedLocation.type === 'selected') {
                        isSelected = true;
                    }
                    // Check totals for requested API before retrieving data
                    this.checkCount(countSettings.countType, countSettings.countValue.id1, countSettings.countValue.id2, isSelected, result.data.payload);

                } else if (dataType === 'selected_location') {
                    // Process results for a selected Location ID
                    this.processLocationData(locationId, result.data.payload);

                } else {
                    // Process results for date range with optional filter
                    this.processData(dataType, dataIsFiltered, result.data.payload);
                }
            }
        }).catch((error) => {
            let message = Config.fuse.error.error + reportName + '.';
            let errorMessage1 = (this.state.errorMessage1) ? this.state.errorMessage1 : null;
            let errorMessage2 = (this.state.errorMessage2) ? this.state.errorMessage2 : null;
            if (error.response) {
                // Server response outside 2xx
                if (error.response.data && error.response.data.error) {
                    message = Config.fuse.error.error + reportName + ': ' + error.response.data.error;
                }
            } else if (error.request) {
                // No response
                message = Config.fuse.error.no_response + reportName + '.';
            } else {
                console.log('Error', error.message);
            }
            if (dataType === 'selected_location') {
                errorMessage2 = message;
            } else {
                errorMessage1 = message;
            }
            this.setState({
                errorMessage1: errorMessage1,
                errorMessage2: errorMessage2,
                loadingData1: this.props.showLoading,
                loadingData2: false
            });
        });
    }

    /* Data Processing ------------------------------ */

    /**
     * Check Location result totals before retrieving data for selected or filtered Location
     *
     * @param type
     * @param id1
     * @param id2
     * @param isSelected
     * @param data
     */
    checkCount(type, id1, id2, isSelected, data) {

        let countValid = true;
        let aggs = data.aggregations;
        if (aggs) {
            let products_returned = (
                aggs.products_returned &&
                aggs.products_returned.products_returned_count &&
                aggs.products_returned.products_returned_count.value
            )
                ? aggs.products_returned.products_returned_count.value : 0;
            let products_sold = (
                aggs.products_sold &&
                aggs.products_sold.products_sold_count &&
                aggs.products_sold.products_sold_count.value
            )
                ? aggs.products_sold.products_sold_count.value : 0;

            // If any result count would pass 10k, prevent the call
            if (products_returned > 9999 || products_sold > 9999) {
                countValid = false;
            }
        }
        // Store the value and proceed if applicable
        this.setState({
            countValid: countValid
        }, () => {
            // If the count is valid, proceed with the original call
            if (countValid) {
                // Locations might be selected instead of filtered
                if (isSelected) {
                    this.setDataForFetch('selected_location', id1);
                } else {
                    this.setDataForFetch(type);
                }
            }
        });
    }

    /**
     * Process API results of Locations and Categories by Date Range (Table Set 1)
     *
     * @param dataType
     * @param dataIsFiltered
     * @param data
     */
    processData(dataType, dataIsFiltered, data) {

        // Create empty arrays for first table set
        let headerSet1 = {
            type: null,
            choice: null
        };
        let tableSet1Categories = [];
        let tableSet1Products = [];
        let tableSet1Locations = [];
        const emptyCurrency = toCurrency(0);

        if (data.aggregations) {

            // Assemble data for the Product Units table in Area 1: Item Sales Report
            tableSet1Products = populateProductUnitTable(data, this.props.offset);

            // Assemble data for the Category table in Area 1: Categories Purchased
            tableSet1Categories = populateCategoryTable(data, this.props.offset);

            // Assemble filtered data for each Location row in Area 1: Item Sales Locations
            if (data.aggregations.totals_by_location && data.aggregations.totals_by_location.buckets) {
                let lResults = data.aggregations.totals_by_location.buckets;
                let lTotal = lResults.length;
                if (lTotal) {
                    for (let i = 0; i < lTotal; i++) {
                        let lResult = lResults[i];
                        let location = lResult.column_name.hits.hits[0]._source.rxtxMsg.payload.location;
                        location.id = lResult.column_name.hits.hits[0]._source.rxtxMsg.payload.client.location;
                        let subtotalReturned = emptyCurrency;
                        let subtotalSold = emptyCurrency;
                        let taxReturned = emptyCurrency;
                        let taxSold = emptyCurrency;
                        let totalReturned = emptyCurrency;
                        let totalSold = emptyCurrency;

                        if (lResult.credits && lResult.credits.refund_totals) {
                            if (lResult.credits.refund_totals.credits_subtotal && lResult.credits.refund_totals.credits_subtotal.value) {
                                subtotalReturned = lResult.credits.refund_totals.credits_subtotal.value;
                            }
                            if (lResult.credits.refund_totals.credits_tax && lResult.credits.refund_totals.credits_tax.value) {
                                taxReturned = lResult.credits.refund_totals.credits_tax.value;
                            }
                            if (lResult.credits.refund_totals.credits_currency && lResult.credits.refund_totals.credits_currency.value) {
                                totalReturned = lResult.credits.refund_totals.credits_currency.value;
                            }
                        }
                        if (lResult.payments && lResult.payments.purchased_totals) {
                            if (lResult.payments.purchased_totals.payment_subtotal && lResult.payments.purchased_totals.payment_subtotal.value) {
                                subtotalSold = lResult.payments.purchased_totals.payment_subtotal.value;
                            }
                            if (lResult.payments.purchased_totals.payment_tax && lResult.payments.purchased_totals.payment_tax.value) {
                                taxSold = lResult.payments.purchased_totals.payment_tax.value;
                            }
                            if (lResult.payments.purchased_totals.payment_currency && lResult.payments.purchased_totals.payment_currency.value) {
                                totalSold = lResult.payments.purchased_totals.payment_currency.value;
                            }
                        }
                        let netTotal = subtotalSold - subtotalReturned;

                        // Create a Location row
                        let locationRow = createTableRow('location', location);
                        locationRow.net_total = (netTotal) ? toCurrency(netTotal, true) : emptyCurrency;
                        locationRow.subtotal_returned = (subtotalReturned) ? toCurrency(subtotalReturned, true) : emptyCurrency;
                        locationRow.subtotal_sold = (subtotalSold) ? toCurrency(subtotalSold, true) : emptyCurrency;
                        locationRow.tax_returned = (taxReturned) ? toCurrency(taxReturned, true) : emptyCurrency;
                        locationRow.tax_sold = (taxSold) ? toCurrency(taxSold, true) : emptyCurrency;
                        locationRow.total_returned = (totalReturned) ? toCurrency(totalReturned, true) : emptyCurrency;
                        locationRow.total_sold = (totalSold) ? toCurrency(totalSold, true) : emptyCurrency;

                        // Add the row to the table
                        tableSet1Locations.push(locationRow);
                    }
                }
            }

            // If data is filtered by Location, store a single Location result
            if (dataType === 'location' && data.aggregations.column_name) {
                let aggs = data.aggregations;
                let location = aggs.column_name.hits.hits[0]._source.rxtxMsg.payload.location;
                location.id = aggs.column_name.hits.hits[0]._source.rxtxMsg.payload.client.location;
                let subtotalReturned = emptyCurrency;
                let subtotalSold = emptyCurrency;
                let taxReturned = emptyCurrency;
                let taxSold = emptyCurrency;
                let totalReturned = emptyCurrency;
                let totalSold = emptyCurrency;

                if (aggs.credits && aggs.credits.refund_totals) {
                    if (aggs.credits.refund_totals.payment_subtotal && aggs.credits.refund_totals.payment_subtotal.value) {
                        subtotalReturned = aggs.credits.refund_totals.payment_subtotal.value;
                    }
                    if (aggs.credits.refund_totals.payment_tax && aggs.credits.refund_totals.payment_tax.value) {
                        taxReturned = aggs.credits.refund_totals.payment_tax.value;
                    }
                    if (aggs.credits.refund_totals.payment_currency && aggs.credits.refund_totals.payment_currency.value) {
                        totalReturned = aggs.credits.refund_totals.payment_currency.value;
                    }
                }
                if (aggs.payments && aggs.payments.purchased_totals) {
                    if (aggs.payments.purchased_totals.payment_subtotal && aggs.payments.purchased_totals.payment_subtotal.value) {
                        subtotalSold = aggs.payments.purchased_totals.payment_subtotal.value;
                    }
                    if (aggs.payments.purchased_totals.payment_tax && aggs.payments.purchased_totals.payment_tax.value) {
                        taxSold = aggs.payments.purchased_totals.payment_tax.value;
                    }
                    if (aggs.payments.purchased_totals.payment_currency && aggs.payments.purchased_totals.payment_currency.value) {
                        totalSold = aggs.payments.purchased_totals.payment_currency.value;
                    }
                }
                let netTotal = subtotalSold - subtotalReturned;

                // Create a Location row
                let locationRow = createTableRow('location', location);
                locationRow.net_total = (netTotal) ? toCurrency(netTotal, true) : emptyCurrency;
                locationRow.subtotal_returned = (subtotalReturned) ? toCurrency(subtotalReturned, true) : emptyCurrency;
                locationRow.subtotal_sold = (subtotalSold) ? toCurrency(subtotalSold, true) : emptyCurrency;
                locationRow.tax_returned = (taxReturned) ? toCurrency(taxReturned, true) : emptyCurrency;
                locationRow.tax_sold = (taxSold) ? toCurrency(taxSold, true) : emptyCurrency;
                locationRow.total_returned = (totalReturned) ? toCurrency(totalReturned, true) : emptyCurrency;
                locationRow.total_sold = (totalSold) ? toCurrency(totalSold, true) : emptyCurrency;

                // Add the row to the table
                tableSet1Locations.push(locationRow);
            }

            // Store data for the Area header for this table set
            if (dataIsFiltered && data.aggregations.column_name && data.aggregations.column_name.hits) {
                let dataPayload = data.aggregations.column_name.hits.hits[0]._source.rxtxMsg.payload;
                if (dataPayload && dataPayload.location) {
                    let loc = dataPayload.location;
                    // Set the header based on filter selection, if applicable
                    switch (dataType) {
                        case 'statecity':
                            headerSet1.type = 'City and State';
                            headerSet1.choice = loc.city + ', ' + loc.state;
                            break;
                        case 'statedba':
                            headerSet1.type = 'DBA and State';
                            headerSet1.choice = loc.dba.name + ', ' + loc.state;
                            break;
                        case 'dba':
                            headerSet1.type = 'DBA';
                            headerSet1.choice = loc.dba.name + ' (' + loc.dba.id + ')';
                            break;
                        case 'district':
                            headerSet1.type = 'District';
                            headerSet1.choice = loc.district.name + ' (' + loc.district.id + ')';
                            break;
                        case 'location':
                            headerSet1.type = 'Location';
                            headerSet1.choice = loc.name + ' (' + dataPayload.client.location + ')';
                            break;
                        case 'state':
                            headerSet1.type = 'State';
                            headerSet1.choice = loc.state;
                            break;
                        default:
                            break;
                    }
                }
            }
        }

        // Finalize API data and Points/Location table data
        this.setState({
            dataSet1Complete: true,
            errorMessage1: null,
            headerSet1: {
                type: headerSet1.type,
                choice: headerSet1.choice
            },
            loadingData1: false,
            tableSet1Categories: tableSet1Categories,
            tableSet1Products: tableSet1Products,
            tableSet1Locations: tableSet1Locations
        }, () => {
            this.props.onDataProcessed();
        });
    }

    /**
     * Process API results of Categories, Products and Locations by selected Location in Date Range (Table Set 2)
     *
     * @param id
     * @param data
     */
    processLocationData(id, data) {

        // Create empty arrays for selected Location ID
        let headerSet2 = {
            dba: {
                name: null
            },
            id: null,
            name: null,
            city: null,
            state: null
        };
        let tableSet2Categories = [];
        let tableSet2Products = [];

        if (data.aggregations) {

            // Assemble data for the Category table in Area 2: Categories Purchased
            tableSet2Categories = populateCategoryTable(data, this.props.offset);

            // Assemble data for the Product Units table in Area 2: Item Sales (Product Units)
            tableSet2Products = populateProductUnitTable(data, this.props.offset);

            // Store data for the Area header for this table set
            if (data.aggregations.column_name && data.aggregations.column_name.hits) {
                let dataPayload = data.aggregations.column_name.hits.hits[0]._source.rxtxMsg.payload;
                if (dataPayload && dataPayload.location) {
                    let loc = dataPayload.location;
                    headerSet2.dba = {
                        name: loc.dba.name
                    };
                    headerSet2.id = dataPayload.client.location;
                    headerSet2.name = loc.name;
                    headerSet2.city = loc.city;
                    headerSet2.state = loc.state;
                }
            }
        }

        // Finalize Item Sales by Location table data
        this.setState({
            allowLocationSelection: true,
            errorMessage2: null,
            headerSet2: {
                dba: {
                    name: headerSet2.dba.name
                },
                id: headerSet2.id,
                name: headerSet2.name,
                city: headerSet2.city,
                state: headerSet2.state
            },
            loadingData2: false,
            tableSet2Categories: tableSet2Categories,
            tableSet2Products: tableSet2Products
        });
    }

    /**
     * Store selected Location and make calls
     *
     * @param event
     * @param row
     */
    handleLocationSelect(event, row) {
        const location = {
            id: row.location_id,
            name: row.location_name,
            dba_name: row.dba_name,
            city: row.city,
            selected: true,
            state: row.state,
            type: 'selected',
            zipcode: row.zipcode
        };
        this.setState({
            allowLocationSelection: false,
            allowLoyaltySelection: false,
            loadingData2: true,
            selectedLocation: location
        }, () => {
            this.scrollToArea(2);
            // Check totals for Location before retrieving data
            this.setDataForFetch('location_count', location.id);
        });
    }

    scrollToArea(area) {
        if (area === 2) {
            window.scrollTo(0, this.area2Position.offsetTop);
        }
    }

    render() {

        const {
            endDate,
            startDate,
            system
        } = this.props;

        const {
            allowLocationSelection,
            countValid,
            dataSet1Complete,
            errorMessage1,
            errorMessage2,
            headerSet1,
            headerSet2,
            loadingData1,
            loadingData2,
            selectedLocation,
            tableSet1Categories,
            tableSet1Products,
            tableSet1Locations,
            tableSet2Categories,
            tableSet2Products
        } = this.state;

        return (
            <div>

                {loadingData1 &&
                <div className="loader-container">
                    <h4>Generating Reports...</h4>
                    <CircularProgress
                        size={24}
                        thickness={2}
                        className="loader"
                    />
                </div>
                }

                {!countValid &&
                <div>
                    <div style={tableStyles.error}>
                        <p>The current filter returns too many results to display. Please edit the Date Range filter,
                            or select a different secondary filter, to reduce the total results.</p>
                    </div>
                </div>
                }

                {dataSet1Complete &&
                <div>

                    {/* Area 1: Item Sales by Date Range and Secondary Filter :::::::::::::::::::::::::::::::::::::::: */}

                    <div ref={e => (this.printRef1 = e)}>
                        {/* Report Header Set 1 */}
                        <div className="report-header">
                            <div className="btn-print-container report-header-button-container">
                                <ReactToPrint
                                    trigger={() =>
                                        <RaisedButton
                                            primary
                                            type="button"
                                            label="Print Report"
                                            style={tableStyles.printBtn}/>
                                    }
                                    content={() => this.printRef1}
                                />
                            </div>
                            <h2 className="report-header-title">Item Sales Report</h2>
                            {headerSet1 && headerSet1.type &&
                            <p>
                                <strong>{headerSet1.type}</strong>: {headerSet1.choice}
                            </p>
                            }
                            <p>
                                {displayDateRangeString(startDate, endDate)}
                            </p>
                        </div>

                        {/* Report: Categories */}
                        <CategoriesPurchasedTable
                            tableFilename="Item-Sales-Categories"
                            tableKey="Set1"
                            tableLabel="Categories Purchased"
                            listData={tableSet1Categories}
                            endDate={endDate}
                            startDate={startDate}
                            system={system}
                        />

                        {/* Report: Item Sales by Location */}
                        <LocationSalesTable
                            tableKey="set1"
                            listData={tableSet1Locations}
                            endDate={endDate}
                            startDate={startDate}
                            system={system}
                            allowLocationSelection={allowLocationSelection}
                            locationIconFunction={this.handleLocationSelect}
                        />

                        {/* Report: Item Sales (Product Units) */}
                        <ProductUnitsPurchasedTable
                            tableFilename="Item-Sales-Product-Units"
                            tableKey="Set1"
                            tableLabel="Item Sales Report"
                            listData={tableSet1Products}
                            endDate={endDate}
                            startDate={startDate}
                            system={system}
                        />
                    </div>

                    {/* Error and Messaging for set 1: Item Sales by Date Range and Secondary Filter */}
                    {errorMessage1 &&
                        <div className="error">
                            <p>{errorMessage1}</p>
                        </div>
                    }

                    {/* Area 2: Item Sales by Selected Location :::::::::::::::::::::::::::::::::::::::: */}

                    <div ref={e => (this.printRef2 = e)}>
                        <div ref={(ref) => this.area2Position = ref}>
                        </div>

                        {selectedLocation.id && countValid && loadingData2 &&
                        <div className="loader-container">
                            <h4>Generating Reports...</h4>
                            <CircularProgress
                                size={24}
                                thickness={2}
                                className="loader"
                            />
                        </div>
                        }
                        {!countValid &&
                        <div>
                            <div style={tableStyles.error}>
                                <p>The selected Location has too many results.
                                    Please edit the Date Range filter to reduce the total results.</p>
                            </div>
                        </div>
                        }

                        {(tableSet2Categories.length > 0 || tableSet2Products.length > 0) &&
                        <div className="margin-top">

                            {/* Report Header Set 2 */}
                            <div className="report-header">
                                <div className="btn-print-container report-header-button-container">
                                    <ReactToPrint
                                        trigger={() =>
                                            <RaisedButton
                                                primary
                                                type="button"
                                                label="Print Report"
                                                style={tableStyles.printBtn}/>
                                        }
                                        content={() => this.printRef2}
                                    />
                                </div>
                                <h2 className="report-header-title">{headerSet2.id} Item Sales Report</h2>
                                {headerSet2 && headerSet2.id && headerSet2.name &&
                                <p>
                                    <strong>Location Name</strong>: {headerSet2.name}<br/>
                                    {headerSet2.city &&
                                    <span>{headerSet2.city}, </span>
                                    }
                                    {headerSet2.state &&
                                    <span>{headerSet2.state}</span>
                                    }
                                    {headerSet2.dba && headerSet2.dba.name &&
                                    <span>{headerSet2.dba.name}</span>
                                    }
                                </p>
                                }
                                <p>
                                    {displayDateRangeString(startDate, endDate)}
                                </p>
                            </div>

                            {/* Report: Item Sales (Product Units) */}
                            {tableSet2Products.length > 0 &&
                            <ProductUnitsPurchasedTable
                                tableFilename="Item-Sales-Product-Units"
                                tableKey="Set2"
                                tableLabel="Item Sales Report"
                                listData={tableSet2Products}
                                endDate={endDate}
                                startDate={startDate}
                                system={system}
                            />
                            }

                            {/* Report: Categories (by selected Location) */}
                            {tableSet2Categories.length > 0 &&
                            <CategoriesPurchasedTable
                                tableFilename="Item-Sales-Categories"
                                tableKey="Set2"
                                tableLabel="Categories Purchased"
                                listData={tableSet2Categories}
                                endDate={endDate}
                                startDate={startDate}
                                system={system}
                            />
                            }
                        </div>
                        }
                    </div>

                    {/* Error and Messaging for set 2: Item Sales by Selected Location */}
                    {errorMessage2 &&
                        <div className="error">
                            <p>{errorMessage2}</p>
                        </div>
                    }
                </div>
                }
            </div>
        )
    }
}

ItemSalesReportSet.propTypes = {
    addField: PropTypes.bool,
    endDate: PropTypes.string,
    filterChoiceFirst: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.object,
        PropTypes.string,
    ]),
    filterChoiceSecond: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.object,
        PropTypes.string,
    ]),
    filterType: PropTypes.string,
    offset: PropTypes.string.isRequired,
    onDataProcessed: PropTypes.func,
    showLoading: PropTypes.bool,
    startDate: PropTypes.string,
    system: PropTypes.string,
    totalFiltersAvailable: PropTypes.number,
};

ItemSalesReportSet.defaultProps = {
    addField: true,
    endDate: null,
    filterChoiceFirst: null,
    filterChoiceSecond: null,
    filterType: 'all',
    offset: null,
    startDate: null,
    showLoading: false,
    totalFiltersAvailable: 0,
};

const enhance = compose(
    connect()
);

export default enhance(ItemSalesReportSet);



// WEBPACK FOOTER //
// ./src/Fuse/components/ItemSalesReportSet.js